import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MakeHash from 'make-hash';

export default class SelectField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      'isOpen': false,
      'value': props.value ? props.value : props.options[0]
    };

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onTriggerClick = this.handleTriggerClick.bind(this);
    this.onOptionClick = this.handleOptionClick.bind(this);
    this.onOffClick = this.toggleDropdown.bind(this);
  }

  handleTriggerClick(event) {
    this.toggleDropdown();
  }

  handleOptionClick(event, value) {
    this.setState({ value });
    this.toggleDropdown();
  }

  toggleDropdown() {
    this.setState({
      'isOpen': !this.state.isOpen
    }, this.toggleOffClickListener);
  }

  /**
   * Sets or removes a document listener while the dropdown is open
   *
   * @method  toggleOffClickListener
   */
  toggleOffClickListener() {
    if (this.state.isOpen) {
      document.addEventListener('click', this.onOffClick);
    } else {
      document.removeEventListener('click', this.onOffClick);
    }
  }

  _renderOptions() {
    return this.props.options.map((option, i) => {
      const optionClasses = classNames(
        'select-option',
        { 'select-option_active': this.state.value === option }
      );

      return (
        <li key={`${option}-${i}`}>
          <button
            className={optionClasses}
            type="button"
            onClick={event => { this.onOptionClick(event, option); }}
          >
            {option}
          </button>
        </li>
      );
    });
  }

  render() {
    const { id, name, label, errorMsg } = this.props;
    const optionList = this._renderOptions();
    const selectClasses = classNames(
      'select',
      {
        'select_active': this.state.isOpen
      }
    );

    return(
      <div className="field">
        <label className="field-label" htmlFor={id}>
          {label}
        </label>
        <div
          className={selectClasses}
          id={id}
          name={name}
          ref={(input) => { this.input = input; }}
        >
          <button
            className="select-title"
            type="button"
            onClick={this.onTriggerClick}
          >
            {this.state.value}
          </button>
          <ul className="select-dropdown">
            {optionList}
          </ul>
        </div>
        <span className="field-error">
          {errorMsg}
        </span>
      </div>
    );
  }
}

SelectField.propTypes = {
  'id': PropTypes.string,
  'name': PropTypes.string,
  'label': PropTypes.string,
  'errorMsg': PropTypes.string,
  'value': PropTypes.string,
  'options': PropTypes.arrayOf(PropTypes.string)
};



// WEBPACK FOOTER //
// ./src/client/components/fields/select-field.jsx